/* eslint-disable new-cap */
import EmblaCarousel, { EmblaCarouselType } from 'embla-carousel'
import ClassNames from 'embla-carousel-class-names'

interface AvailableDirections {
  prev: boolean
  next: boolean
}

interface BlogState {
  el: HTMLElement
  slider: EmblaCarouselType
  activeSlideIndex: number
  availableDirections: AvailableDirections
}

function updateAvailableDirections(
  state: BlogState,
  directions: AvailableDirections
): void {
  Object.entries(directions).forEach(([direction, isAvailable]) => {
    const button = state.el.querySelector<HTMLButtonElement>(
      `[data-slider-button][data-dir="${direction}"]`
    )

    if (!button) return

    button.classList.toggle('is-hidden', !isAvailable)
  })
}

function setActiveSlideIndex(state: BlogState, newValue: number): void {
  if (newValue === state.activeSlideIndex) {
    return
  }

  state.activeSlideIndex = newValue
  state.slider.scrollTo(newValue)

  const newDirections: AvailableDirections = {
    prev: state.slider.canScrollPrev(),
    next: state.slider.canScrollNext()
  }

  state.availableDirections = newDirections
  updateAvailableDirections(state, newDirections)
}

export function initBlog(): void {
  const sliderEl = document.querySelector<HTMLElement>('[data-blog]')
  if (!sliderEl) {
    return
  }

  const state: BlogState = {
    el: sliderEl,
    slider: EmblaCarousel(
      sliderEl,
      {
        align: 'center',
        containScroll: 'trimSnaps'
      },
      [ClassNames()]
    ),
    activeSlideIndex: 0,
    availableDirections: {
      prev: false,
      next: true
    }
  }

  state.slider.on('init', () => {
    setActiveSlideIndex(state, state.slider.selectedScrollSnap())
    updateAvailableDirections(state, state.availableDirections)
  })

  state.slider.on('reInit', () => {
    setActiveSlideIndex(state, state.slider.selectedScrollSnap())
  })

  state.slider.on('select', () => {
    setActiveSlideIndex(state, state.slider.selectedScrollSnap())
  })

  sliderEl.addEventListener('click', (event: MouseEvent) => {
    const button = (event.target as HTMLElement).closest<HTMLButtonElement>(
      '[data-slider-button]'
    )
    if (!button) {
      return
    }

    const delta = button.dataset.dir === 'next' ? 1 : -1
    setActiveSlideIndex(state, state.activeSlideIndex + delta)
  })
}
